function _(n,o,t){o.exports=function(n){if("function"!=typeof n)throw new TypeError(n+" is not a function");return n}}
//# sourceMappingURL=valid-callable.min.js.map